import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SymbolGroup } from '../../shared/models/symbol-group';
import { SymbolData } from '../../shared/models/symbol-data';

@Component({
    selector: 'ldw-select-symbol-dialog',
    templateUrl: './select-symbol-dialog.component.html',
    styleUrls: ['./select-symbol-dialog.component.css'],
    standalone: false
})
export class SelectSymbolDialogComponent {
  dialogRef = inject<MatDialogRef<SelectSymbolDialogComponent, SymbolData>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  symbols: SymbolGroup[];

  constructor() {
      this.symbols = this.data;
  }

  select(symbol: SymbolData) {
    this.dialogRef.close(symbol)
  }

  abort() {
    this.dialogRef.close(undefined);
  }

}
